import * as Blockly from "blockly";

// Variables / Functions flyouts are generated by Blockly from the student's own names.
// These wrappers reproduce them minus the block types a question hides.
const filterItems = (items, banned) => items.filter((it) => it.kind !== "block" || !banned.has(it.type));

// Blockly's procedure flyout only offers "define" blocks; call blocks appear as functions get defined.
// If a "define" variant is hidden, hide its call blocks too so students can't smuggle them in.
const PROCEDURE_PAIRS = { procedures_defnoreturn: "procedures_callnoreturn", procedures_defreturn: "procedures_callreturn" };

export const registerFilteredCategories = (ws, bannedBlocks) => {
  const banned = new Set(bannedBlocks || []);
  Object.entries(PROCEDURE_PAIRS).forEach(([def, call]) => { if (banned.has(def)) banned.add(call); });
  ws.registerToolboxCategoryCallback("CD_VARIABLE", (workspace) => filterItems(Blockly.Variables.flyoutCategory(workspace, false), banned));
  ws.registerToolboxCategoryCallback("CD_PROCEDURE", (workspace) => filterItems(Blockly.Procedures.flyoutCategory(workspace, false), banned));
};
